import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

export default function NewsQuickList({ items }: { items: NewsItem[] }) {
  return (
    <ol className="divide-y divide-background-200">
      {items.map((item, index) => (
        <li key={item.id}>
          <Link
            to={`/news/detail/${item.id}`}
            className="group flex items-start gap-3 md:gap-4 py-4 hover:bg-background-100/70 -mx-3 px-3 rounded-md transition-colors"
          >
            <span
              className={`w-6 h-6 shrink-0 rounded-md text-xs font-heading flex items-center justify-center mt-0.5 ${
                index < 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-500"
              }`}
            >
              {index + 1}
            </span>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base text-foreground-900 font-body leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 mt-1.5 line-clamp-1 font-body">
                {item.summary}
              </p>
            </div>
            <span className="hidden sm:block text-xs text-foreground-400 font-body whitespace-nowrap shrink-0 mt-0.5">
              {item.date}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}